import {bannerAd, topMPUProps, bottomMPUProps} from "../Common/components/GptProperties";

const leaderboardAd = {
  view: 'racing'
};

const topMPU = {
  component: 'GooglePublisherTag',
  props: topMPUProps,
  desktopColumn: 'right',
  desktopOrder: 1,
  handheldOrder: false
};

const bottomMPU = {
  component: 'GooglePublisherTag',
  props: bottomMPUProps,
  desktopColumn: 'right',
  desktopOrder: 3,
  handheldOrder: false
};

const advertMPU = {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["homepage", "mpu"],
    additionalProperties: {
      view: "racing"
    }
  },
  desktopColumn: "right",
  desktopOrder: 4,
  handheldOrder: false
};

const defaultSideBarComponents = [topMPU, bottomMPU, advertMPU];

const withAdverts = (...components) => ({
  bannerAd,
  leaderboardAd,
  components: [...components, ...defaultSideBarComponents]
});

const PrivacyPolicyPageLayout = withAdverts({
    component: "PrivacyPolicy",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  }
);

const PreviousPrivacyPolicyPageLayout = withAdverts({
  component: "PreviousPrivacyPolicy",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}
);


export default {
  '/privacy': PrivacyPolicyPageLayout,
  '/privacy-previous': PreviousPrivacyPolicyPageLayout
};



// WEBPACK FOOTER //
// ./modules/PrivacyPolicy/layouts.js